import script from "./HelpCard.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpCard.vue?vue&type=script&setup=true&lang=js"

import "./HelpCard.vue?vue&type=style&index=0&id=66d9faaf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66d9faaf"]])

export default __exports__